import React from 'react';
import {observer} from "mobx-react";
import LinearProgress from '@material-ui/core/LinearProgress';
import {apiActivity} from '../../api';

/* Thin progress bar at the bottom of the app bar while API requests are running. */
function ApiProgress()
{
    if (apiActivity.pending === 0)
    {
        return null;
    }

    return <LinearProgress color="secondary" style={{position: "absolute", left: 0, right: 0, bottom: 0, height: 3}}/>;
}

export default observer(ApiProgress);
